import { HStack, RadioGroup, VStack } from "@gluestack-ui/themed";
import { Text } from "../Text";
import { SelectTransactionListProps } from "./types";
import { SelectTransactionItem } from "./components/SelectTransactionItem";
import { format } from "date-fns";
import { SelectTransactionsListLoading } from "./loading";
import { EmptyState } from "../../layout/EmptyState";

export const SelectTransactionsList = ({
  title,
  date,
  isLoading,
  transactions,
  selected,
  onChange
}: SelectTransactionListProps) => {
  if (!isLoading && !transactions.length) {
    return <EmptyState flex={1} text="Nenhuma transação para cancelamento" />;
  }

  return (
    <VStack>
      <HStack w="$full" mb="$6" alignItems="center">
        <Text flex={1} fontWeight={500} fontSize="$sm" color="$textLight800">
          {title || ""}
        </Text>
        <Text>{format(date, "dd/MM/yyy")}</Text>
      </HStack>
      <VStack gap={4}>
        <HStack alignItems="center" justifyContent="space-between" px="$4">
          <VStack flex={1} alignItems="flex-start">
            <Text fontSize="$xs">Autorização</Text>
          </VStack>
          <VStack flex={0.8} alignItems="center" pr="$4">
            <Text fontSize="$xs">Operação</Text>
          </VStack>
          <VStack flex={0.8} alignItems="center" pr="$4">
            <Text fontSize="$xs">Cartão</Text>
          </VStack>
          <VStack flex={1} alignItems="flex-end">
            <Text fontSize="$xs">Valor</Text>
          </VStack>
        </HStack>

        {!isLoading ? (
          <RadioGroup gap={8} mt="$2">
            {transactions?.map((item) => (
              <SelectTransactionItem
                key={item.value}
                {...item}
                isSelected={selected === item?.authorizationId?.toString()}
                onChange={onChange}
              />
            ))}
          </RadioGroup>
        ) : (
          <SelectTransactionsListLoading />
        )}
      </VStack>
    </VStack>
  );
};
